<template>
  <div class="side-nav">
    <div class="side-nav-title">
      管理システム
    </div>

    <div
      v-for="(item, index) in items"
      :key="index"
      class="side-nav-item"
      :class="styleSelected(item)"
      @click="goTo(item)">
      {{ item.title }}
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      items: [
        { title: 'ホーム', name: 'home' },
        { title: 'イベント', name: 'event' },
        { title: 'イベント(クローズド)', name: 'event-closed' },
        { title: 'ユーザー', name: 'user' },
        { title: 'お知らせ', name: 'info' },
        { title: 'メッセージ', name: 'message' },
        { title: 'クイズセット', name: 'quizset' },
        { title: '観光ポイント', name: 'tourism' },
        { title: 'ログアウト', name: 'login' }
      ]
    }
  },
  methods: {
    goTo: function (item) {
      if (item.name === 'login') {
        this.$store.getters.Parse.User.logOut()
      }
      this.$router.push({ name: item.name })
    },
    styleSelected: function (item) {
      if (this.$route.meta.navName === item.name) {
        return {
          'side-nav-item_selected': true
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.side-nav {
  position: sticky;
  top: 0;
  width: 240px;
  height: 100vh;
  background: rgba(41, 128, 185,1.0);
}

.side-nav-item {
  color: #bdc3c7;
}

.side-nav-title {
  padding: 10px;
  font-size: 1.2em;
  color: white;
  padding: 10px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.5);
}

.side-nav-item {
  padding: 10px;
  font-size: 1.2em;
  &:hover {
    cursor: pointer;
    background: rgba(255, 255, 255, 0.2)
  }
}

.side-nav-item_selected {
  color: #34495e;
  background: #ecf0f1 !important;
}
</style>
